import BaseListPresenter from "../../base/BaseListPresenter";
import { findObjectUseCase } from "../../usecases/object";

class ReportManagementPresenter extends BaseListPresenter {
  init() {
    this.limit = 20;
    this.where = {
      rolesName: "QA",
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.filterDate = {};
    this.filterDates = {};
    this.reset();
  }

  componentDidMount() {
    this.init();
    this.getAllEndorsement();
    return this.getObjects();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }
  async getObjectss() {
    this.reset();
    // await this.countObjects();
    // await this.findObjects();
    await this.getAllEndorsement();
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async getAllEndorsement() {
    const query = {
      include: ["location", "timeline"],
      where: {
        ...this.filterDates,
      },
    };

    const object = await findObjectUseCase().execute("endorsement", query);
    console.log("getall", object);
    this.view.setState({ agentForm: object });
  }

  onClickAdd() {
    this.view.navigateTo("/endorsement-form");
  }

  onClickItem(index) {
    const object = this.objects[index];
    this.view.navigateTo("/endorsement-form/" + object.id);
  }
  onChangeDate2(where) {
    this.filterDates = where;
    this.getObjectss();
  }

  onChangeDate(where) {
    this.filterDate = where;
    this.getObjects();
  }
}

export default ReportManagementPresenter;
